
import { oz } from '@weft/utils';
import { TierDiscountConfigurationSchema } from './tier-discount-configuration';

export const TierUsageDataSchema = oz.object({
  tierIndex: oz.number().nonnegative(),
  periodUnits: oz.number().nonnegative(),
  price: oz.number().nonnegative(),
  discountConfiguration: TierDiscountConfigurationSchema.nullable(),
}).openapi('TierUsageData');

export type TierUsageData = oz.infer<typeof TierUsageDataSchema>;